import type { Map as MapLibreMap } from 'maplibre-gl';

export const TERRAIN_SOURCE_ID = 'terrain-dem';
export const MAP_SETTINGS_STORAGE_KEY = 'efb-settings';

export interface AppSettings {
  coordinateFormat: 'DD' | 'DMS' | 'DDM' | 'UTM' | 'MGRS';
  units: 'nautical' | 'statute' | 'metric';
  mapBearing: boolean;
  mapTerrain3d: boolean;
  terrainExaggeration: number;
  owmApiKey: string;
  darkMode: boolean;
}

export const DEFAULT_MAP_SETTINGS: AppSettings = {
  coordinateFormat: 'DD',
  units: 'nautical',
  mapBearing: true,
  mapTerrain3d: false,
  terrainExaggeration: 1.5,
  owmApiKey: '',
  darkMode: true,
};

export function loadMapSettings(): AppSettings {
  try {
    const raw = localStorage.getItem(MAP_SETTINGS_STORAGE_KEY);
    return raw ? { ...DEFAULT_MAP_SETTINGS, ...JSON.parse(raw) } : DEFAULT_MAP_SETTINGS;
  } catch {
    return DEFAULT_MAP_SETTINGS;
  }
}

export function saveMapSettings(settings: AppSettings): void {
  try { localStorage.setItem(MAP_SETTINGS_STORAGE_KEY, JSON.stringify(settings)); } catch { /* unavailable */ }
}

export function applyMapSettings(map: MapLibreMap, settings: AppSettings): void {
  if (settings.mapBearing) {
    map.dragRotate.enable();
    map.touchZoomRotate.enableRotation();
  } else {
    map.dragRotate.disable();
    map.touchZoomRotate.disableRotation();
  }

  if (!map.getSource(TERRAIN_SOURCE_ID)) return;
  map.setTerrain(settings.mapTerrain3d
    ? { source: TERRAIN_SOURCE_ID, exaggeration: settings.terrainExaggeration }
    : null);
}
